import { Link } from "react-router-dom";

const resourceLinks = [
  {
    title: "What is Aphasia?",
    text: "Learn about aphasia, how common it is, and how to help with communication.",
    to: "/resources/what-is-aphasia",
  },
  {
    title: "Community Resources",
    text: "Videos, podcasts, games, and tools from the aphasia community.",
    to: "/resources/community",
  },
  {
    title: "NAS Newsletter",
    text: "Read and share past issues of the NAS newsletter.",
    to: "/resources/newsletter",
  },
];

export default function ResourcesHub() {
  return (
    <div className="page page--narrow">
      <h1 className="page-title">Resources</h1>
      <ul className="resource-links">
        {resourceLinks.map(({ title, text, to }) => (
          <li key={to}>
            <Link to={to} className="resource-link">
              <span className="resource-link__arrow" aria-hidden="true">↳</span>
              <span>
                <span className="resource-link__title">{title}</span>
                <span className="resource-link__text">{text}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
